export default __webpack_public_path__ + "static/media/arrow_right.4ed4bed0.svg";